// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.signImageCss[data-v-5c48f8fd] {\n  font-size: 20px;\n  font-weight: bold;\n  color: #409eff;\n  margin: 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
